import Vue from "vue";
import swal from "sweetalert";
import availablePermissions from "./permissions";
import { dateFormat } from "./constants";
import { get } from "lodash";

export {
    deletePrompt,
    fulfilledPromise,
    getConfig,
    getCurrentDateStr,
    handleGeneralXhrError,
    handleValidationXhrError,
    warningPrompt,
};

let groupListUrl = null;
let previousUrl = null;
const refreshPageKey = "isRefreshingPage";

export function attendanceDetailUrl() {
    const allowedGroupIds = getAllowedGroupIds();
    if (hasRestrictedGroupAccess() && allowedGroupIds.length == 1) {
        return `/admin/reports/attendances/${allowedGroupIds[0]}`;
    }
    return `/admin/reports/attendances/`;
}

export function attendanceIndexUrl() {
    const allowedGroupIds = getAllowedGroupIds();
    if (hasRestrictedGroupAccess() && allowedGroupIds.length == 1) {
        return `/admin/reports/`;
    }
    return `/admin/reports/attendances/`;
}

export function availableGenders() {
    return JSON.parse($('meta[name="available-genders"]').attr("content"));
}

export function availableMemberMaritalStatuses() {
    return JSON.parse(
        $('meta[name="member-available-maritals"]').attr("content")
    );
}

export function availableMemberStatuses() {
    return JSON.parse(
        $('meta[name="member-available-statuses"]').attr("content")
    );
}

export function canAccessGroup(id) {
    const allowedGroupIds = getAllowedGroupIds();
    return allowedGroupIds.includes(id);
}

export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}

function deletePrompt({
    name = "Data",
    onConfirm = () => {},
    text = `${name} akan dihapus dari database`,
    title = `Hapus ${name}?`,
}) {
    return swal({
        title: title,
        text: text,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        buttons: ["Batal", "OK"],
    }).then(async (confirmed) => {
        if (!confirmed) return;
        onConfirm();
    });
}

export function defaultMemberStatus() {
    const availableStatuses = availableMemberStatuses();
    return _.get(availableStatuses, "0", null);
}

export function emptyPromise() {
    return new Promise((resolve) => {
        resolve(null);
    });
}
export function forceInt(value) {
    let parsed = parseInt(value);
    if (isNaN(parsed)) {
        parsed = 0;
    }
    return parsed;
}

export function formatForDateInput(date) {
    const formattedDate = moment(date).format(dateFormat);
    return formattedDate === "Invalid date" ? date : formattedDate;
}

function fulfilledPromise(content = null) {
    return new Promise((resolve, reject) => {
        resolve(content);
    });
}

export function generateRandomString(length = 10) {
    // Create a random string of specified length
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

/**
 * @returns array
 */
export function getAllowedGroupIds() {
    return $('meta[name="allowed-group-ids"]').length > 0
        ? JSON.parse($('meta[name="allowed-group-ids"]').attr("content"))
        : [];
}

export function getAvailableMetrics() {
    return JSON.parse(getConfig("available-metrics"));
}

function getConfig(key, defaultValue = undefined) {
    const config = $(`meta[name="${key}"]`);
    if (config.length < 1) {
        return defaultValue;
    }
    return config.attr("content");
}

function getCurrentDateStr() {
    return moment().format(dateFormat);
}

export function getGroupListUrl() {
    return groupListUrl || "/admin/groups";
}

export function getPreviousUrl() {
    return previousUrl;
}

/**
 * @returns array
 */
export function getLoggedGroupPermissions() {
    return JSON.parse(
        $('meta[name="logged-group-permissions"]').attr("content")
    );
}

export function getLoggedUser() {
    const user = getConfig("logged-user");
    if (!user) {
        return null;
    }
    return JSON.parse(user);
}

/**
 * @returns array
 */
export function getLoggedUserPermissions() {
    return JSON.parse(
        $('meta[name="logged-user-permissions"]').attr("content")
    );
}

export function groupIndexUrl() {
    const allowedGroupIds = getAllowedGroupIds();
    if (hasRestrictedGroupViewPermission() && allowedGroupIds.length == 1) {
        return `/admin/groups/${allowedGroupIds[0]}`;
    }
    return getGroupListUrl();
}

function handleGeneralXhrError(request, callback = (error) => {}) {
    return request.catch((error) => {
        if (pageIsRefreshing()) {
            return;
        }
        if (shouldRefreshPage(error)) {
            refreshPage();
            return;
        }
        Vue.notify({
            type: "error",
            title: "Error",
            text: _.get(error, "response.data.message", error.message),
        });
        callback(error);
    });
}

function handleValidationXhrError(
    request,
    callback = (errors) => {},
    autoRefreshWhenExpired = true
) {
    return request.catch((error) => {
        const errors = _.get(error, "response.data.errors", {});
        const customMessage = _.get(error, "response.data.message");

        if (pageIsRefreshing()) {
            return;
        }

        if (shouldRefreshPage(error, autoRefreshWhenExpired)) {
            refreshPage();
            return;
        }

        Vue.notify({
            type: "error",
            title: "Terjadi Kesalahan",
            text:
                customMessage ??
                _.get(error, "message", "Ada kesalahan pada pengisian data"),
        });

        callback(
            Object.keys(errors).reduce((obj, key) => {
                return {
                    ...obj,
                    [key]: _.get(errors, key, []).join(", "),
                };
            }, {})
        );
    });
}

export function hasGroupPermission(humanFriendlyPermission) {
    return hasPermission(humanFriendlyPermission, getLoggedGroupPermissions());
}

export function hasPermission(
    humanFriendlyPermission,
    loggedUserPermissions = []
) {
    const permission = _.get(availablePermissions, humanFriendlyPermission);

    if (typeof permission === "undefined") {
        throw Error(`Undefined permission: ${humanFriendlyPermission}`);
    }

    const found = loggedUserPermissions.filter((item) => item === permission);
    return found.length > 0;
}

export function hasRestrictedGroupAccess() {
    return $('meta[name="allowed-group-ids"]').length > 0;
}

export function hasRestrictedGroupViewPermission() {
    if (hasUserPermission("viewGroups")) {
        return false;
    }
    return (
        hasUserPermission("groupRestriction") &&
        hasGroupPermission("viewGroups")
    );
}

export function hasUserPermission(humanFriendlyPermission) {
    return hasPermission(humanFriendlyPermission, getLoggedUserPermissions());
}

export function hideOpenDropdowns() {
    try {
        $(window).trigger("hide.bs.dropdown");
    } catch (e) {}
}

export function isBlob(input) {
    return input instanceof Blob;
}

export function isFile(input) {
    return input instanceof File;
}

export function isObject(variable) {
    return typeof variable === "object";
}

export function isString(variable) {
    return typeof variable === "string";
}

export function isTranslationBillingAdmin(user) {
    return (
        get(user, "email") ===
        getConfig("translation-billing-admin", "bondansebastian@gmail.com")
    );
}

function pageIsRefreshing() {
    return _.get(window, refreshPageKey, false);
}

function refreshPage() {
    let countdown = 5;
    window[refreshPageKey] = true;
    Vue.notify({
        type: "warn",
        title: "Sistem Diam Terlalu Lama",
        text: `Untuk keamanan Anda, halaman ini akan segera di-refresh oleh sistem dalam <span id="notification-countdown">${countdown}</span>.`,
        duration: 5000,
    });
    setTimeout(() => {
        window.location.reload();
    }, 5000);
    const countdownHandler = setInterval(() => {
        countdown -= 1;
        $("#notification-countdown").text(countdown);
        if (countdown <= 0) {
            clearInterval(countdownHandler);
        }
    }, 1000);
}

export function setGroupListUrl(url) {
    groupListUrl = url;
}

export function setPreviousUrl(url) {
    previousUrl = url;
}

function shouldRefreshPage(error, shouldAutoRefresh = true) {
    const expiryStatuses = [401, 419];
    return (
        expiryStatuses.indexOf(_.get(error, "response.status")) !== -1 &&
        shouldAutoRefresh
    );
}

function warningPrompt({ title, text, onConfirm = () => {} }) {
    return swal({
        title: title,
        text: text,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        buttons: ["Tidak", "Ya"],
    }).then(async (confirmed) => {
        if (!confirmed) return;
        onConfirm();
    });
}
